import { createGlobalStyle } from 'styled-components';
import { theme } from '.';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "SFProDisplay";
    font-display: swap;
    font-weight: normal;
    font-style: normal;
    src: local('SF Pro Display'), local('SFProDisplay'),
      url('/fonts/SFProDisplay.woff2') format("woff2"), 
      url('/fonts/SFProDisplay.woff') format("woff"),
      url('/fonts/SFProDisplay.ttf') format("truetype");
  }

  @font-face {
    font-family: "Oxygen Mono";
    font-display: swap;
    font-weight: normal;
    font-style: normal;
    src: local('Oxygen Mono'), 
      url('/fonts/OxygenMono.woff2') format("woff2"), 
      url('/fonts/OxygenMono.woff') format("woff"),
      url('/fonts/OxygenMono.ttf') format("truetype"),
      url('/fonts/OxygenMono.eot?#iefix') format('embedded-opentype');
  }

  * {
    box-sizing: border-box;

    /* width */
    ::-webkit-scrollbar {
      height: 4px;
      width: 4px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1; 
      border-radius: 4px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888; 
      border-radius: 4px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555; 
    }
  }

  html,
  body {
    font-family: ${theme.fonts.primary};
    min-height: 100%;
    min-width: 320px;
    padding: 0;
    margin: 0;
  }

  h1, h2, h3, h4, h5, h6, p {
    font-weight: 100;
  }

  h1 {
    font-size: 64px;
    
    @media ${theme.devices.sm} {
      font-size: 48px;
    }
  }

  h2 {
    font-size: 48px;

    @media ${theme.devices.sm} {
      font-size: 36px;
    }
  }

  h3 {
    font-size: 32px;

    @media ${theme.devices.sm} {
      font-size: 28px;
    }
  }

  h4 {
    font-size: 24px;
  }

  h5 {
    font-size: 20px;
  }

  h6 {
    font-size: 18px;
  }

  p {
    font-size: 16px;
  }

  code {
    font-family: ${theme.fonts.code};
  }
`;

export default GlobalStyles;
